import Product from "../../../../../@types/Product";
import SelectOption from "../../../../../@types/SelectOption";
import LugNuts from "../../Shared/LugNuts";

const ChromeLugnut = LugNuts[0];

const WheelSizeOptions: SelectOption[] = [
    { label: `12"`, value: 12, disabled: false, disabledMessage: ''},
    { label: `14"`, value: 14, disabled: true, disabledMessage: '| only available with XSeries Chassis' },
    { label: `15"`, value: 15, disabled: true, disabledMessage: '| only available with XSeries Chassis' },
]

const Wheels12In: Product[] = [
    {
        id: 1,
        refId: 12,
        name: '12" GTW Spyder - Black with Machined Accents x4',
        sku: '19-218',
        img: `${process.env.PUBLIC_URL}/cart-part-images/shared/wheels/12-inch/gtw-12-spyder-blackmachined-300x300.jpg`,
        price: 220.00,
        retailPrice: 0.00,
        linkedProducts: [ChromeLugnut],
        configuratorImg: 'https://imagedelivery.net/8VO3fVWhjd7OVEhtl_T8-g/894d4ffc-63c6-403c-bb63-9f8ed061bc00'
    },
]

const Wheels12InLifted: Product[] = [
    {
        id: 1,
        refId: 12,
        name: '12" GTW Spyder - Black with Machined Accents x4',
        sku: '19-218',
        img: `${process.env.PUBLIC_URL}/cart-part-images/shared/wheels/12-inch/gtw-12-spyder-blackmachined-300x300.jpg`,
        price: 220.00,
        retailPrice: 0.00,
        linkedProducts: [ChromeLugnut],
        configuratorImg: 'https://imagedelivery.net/8VO3fVWhjd7OVEhtl_T8-g/a4888fff-397a-4c97-3b8c-040bc6a6a400'
    },
]

export { Wheels12In, Wheels12InLifted, WheelSizeOptions };